import React from 'react';
import { AppLayout } from '@/components/layout/AppLayout';

const HELP_SECTIONS = [
  {
    title: 'Forging Manuscripts',
    description: 'Learn how to utilize the Scriptorium Engine to generate high-density prose from simple instructions.',
    icon: 'auto_awesome',
    items: [
      'Using the command interface',
      'Structural density parameters',
      'Calibrating linguistic style'
    ]
  },
  {
    title: 'Collaboration Protocols',
    description: 'Manage permissions and roles for scribes and editors assigned to your works.',
    icon: 'group',
    items: [
      'Inviting new scribes',
      'Role definitions (Author, Editor, Viewer)',
      'Shared archive access'
    ]
  },
  {
    title: 'Archival Management',
    description: 'Ensure your manuscripts are properly preserved in the digital vaults.',
    icon: 'archive',
    items: [
      'Exporting to PDF/HTML',
      'Versioning and historical logs',
      'Public vs Private archives'
    ]
  }
];

export function HelpPage() {
  return (
    <AppLayout>
      <div className="flex-1 bg-surface-container-low overflow-y-auto">
        <header className="bg-surface border-b border-outline-variant px-4 md:px-margin-page py-12">
          <div className="max-w-max-width-doc mx-auto">
             <span className="font-label-caps text-label-caps text-primary uppercase tracking-widest mb-2 block">Instructional</span>
             <h1 className="font-h1 text-h1 text-on-surface mb-4">The Scriptorium Guide</h1>
             <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl">
               Technical documentation and procedural guidelines for utilizing the DocForge environment. Every scribe must be familiar with these protocols.
             </p>
          </div>
        </header>

        <main className="px-4 md:px-margin-page py-12">
          <div className="max-w-max-width-doc mx-auto space-y-12">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-gutter">
              {HELP_SECTIONS.map((section) => (
                <div key={section.title} className="bg-surface border border-outline-variant rounded-xl p-8 space-y-6 shadow-sm">
                  <div className="w-12 h-12 rounded bg-primary-container text-on-primary-container flex items-center justify-center">
                    <span className="material-symbols-outlined">{section.icon}</span>
                  </div>
                  
                  <div className="space-y-2">
                    <h3 className="font-h3 text-h3 text-[20px] text-on-surface">{section.title}</h3>
                    <p className="font-body-md text-body-md text-on-surface-variant leading-relaxed">
                      {section.description}
                    </p>
                  </div>
                  
                  <ul className="space-y-3 pt-4 border-t border-outline-variant/30">
                    {section.items.map(item => (
                      <li key={item} className="flex items-center gap-3 font-body-md text-on-surface-variant text-sm">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary shrink-0"></span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <section className="bg-surface border border-outline-variant rounded-2xl p-8 md:p-12 space-y-8 ink-drop-shadow">
               <div className="flex items-center gap-4">
                  <span className="material-symbols-outlined text-[32px] text-primary">contact_support</span>
                  <h2 className="font-h2 text-h2 text-[28px]">Direct Inquiries</h2>
               </div>
               <p className="font-body-md text-body-md text-on-surface-variant max-w-2xl leading-relaxed">
                 If you encounter an anomaly within the forge or require advanced structural assistance, issue a formal inquiry to the Master Scribes.
               </p>
               <div className="flex flex-wrap gap-4 pt-4">
                  <button className="bg-primary text-on-primary px-8 py-3 rounded font-label-caps text-label-caps uppercase tracking-widest shadow-md">
                    Open Support Ticket
                  </button>
                  <button className="bg-surface border border-outline-variant text-on-surface px-8 py-3 rounded font-label-caps text-label-caps uppercase tracking-widest hover:bg-surface-container-high transition-colors">
                    Community Forum
                  </button>
               </div>
            </section>
          </div>
        </main>
      </div>
    </AppLayout>
  );
}
